if(jQuery) (function($){

	$.fn.scrollToAnchor = function(params){
		// default configuration
		var conf = $.extend({
			scrollSpacing: 200,
			highlightSpacing: 220,
			showFrom: false,
			scrollTopButton: false,
			scrollToTopText: 'top',
		}, params);
		// end default configuration
		return this.each(function(){
			var configuration = conf,
				object = $(this),
				object_functions = this,
				link = $('a[href*=#]', object),
				menuHeight = object.outerHeight(),
				placeholderBlock = $('<div></div>'),
				placeholderBlockClass = ".scrolltoanchorplaceholder",
				scrollToTopElem = $('<div>'),
				scrollToTopClass = ".scrollToAnchor-scrolltop",
				userScrollTop,
				positionToTop,
				anchorId,
				anchors = [];
			$.extend(object_functions,{

				init:function(){
					object.addClass('scrollToAnchorMenu')
					if ($(placeholderBlockClass).length) { 
						$(placeholderBlockClass).css({'height':0});
					} else {
						//create elements
						object.before(placeholderBlock.addClass(placeholderBlockClass.replace('.','')).css({'height':0}));
					}
					link.each(function() {
						if ($(anchorId).length) {
							anchorId = $(this).attr('href');
							anchors.push([anchorId, $(anchorId).offset().top]);
						}
					});

					object_functions.scrollToItem();

					$(window).on('load scroll resize', function() {
						//if enabeled add fixed menubar
						if(object_functions.enabled(object)) {
							userScrollTop = $(window).scrollTop();
							//add events to items
							object_functions.highlightItem();
							//fix menu
							object_functions.setFixed();
							//remove scrollTopButton
							object_functions.removeScrollToTopButton();
						} else {
							//remove scrolled & fixed menu
							object.removeClass('scrolled');
							$(placeholderBlockClass).css({'height':0});
							//show scrollTopButton
							if(configuration.scrollTopButton) {
								object_functions.addScrollToTopButton();
								object_functions.toggleScrollToTopButton();
							}
						}
					});
				},
				enabled : function(object) { 
					//default when menu is visible 
					if(!configuration.showFrom) {
						return object.is(':visible'); 
					//add minimum width to function if showFrom is set
					} else {
						return (object.is(':visible') && $(window).width() > configuration.showFrom)
					}
				},
				setFixed: function() {
					positionToTop = $(placeholderBlockClass).offset().top;
					if(userScrollTop >= positionToTop){
						object.addClass('scrolled');
						$(placeholderBlockClass).css({'height': menuHeight});
					}else{
						object.removeClass('scrolled');
						$(placeholderBlockClass).css({'height':0});
					}
				},
				scrollToItem:function(){
					link.click(function(e) {
						var anchorId = $(this).attr('href');
						if ($(anchorId).length) {
							e.preventDefault();
							$('html, body').animate({
								scrollTop: $(anchorId).offset().top - menuHeight - configuration.scrollSpacing
							});
						}
					});
				},
				highlightItem:function() {
					link.each(function() {
						var currentLink = $(this),
							currentLinkAnchor = $(currentLink.attr('href'));
						if(currentLinkAnchor.length) {
							//bottom of page
							if (userScrollTop + $(window).height() +20 >= $(document).height()) {
								link.removeClass('active');
								link.last().addClass('active');
							//active link
							} else if((currentLinkAnchor.offset().top - menuHeight - configuration.highlightSpacing) < userScrollTop){
								link.removeClass('active');
								currentLink.addClass('active');
							} else	{
							}
						}
					});
				},
				addScrollToTopButton: function() {
					if (!$(scrollToTopClass).length) {
						scrollToTopElem
							.addClass(scrollToTopClass.replace('.',''))
							.html(configuration.scrollToTopText);
						//add elem
						$('body').append(scrollToTopElem);
						//add click
						$(scrollToTopClass).click(function(e) {
							e.preventDefault();
							object_functions.scrollToTop();
						});
					}
				},
				removeScrollToTopButton: function() {
					$(scrollToTopClass).remove();
				},
				toggleScrollToTopButton: function(){
					if(!$(scrollToTopClass).hasClass('scrolled') && $(window).scrollTop() >= $(window).height()) {
						$(scrollToTopClass).addClass('scrolled');
					} else if ($(scrollToTopClass).hasClass('scrolled') && $(window).scrollTop() < $(window).height()) {
						$(scrollToTopClass).removeClass('scrolled');
					}
				},
				scrollToTop: function() {
					 $("html, body").animate(
						{ scrollTop: 0 }
					);
				},
				
			});
			object_functions.init();
		})
	};
})(jQuery);
